function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgKalender = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "kalender",
    transform: "matrix(0.881902,0,0,0.881902,9.11519,9.16911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,29.5C11,29.776 10.776,30 10.5,30L3.5,30C3.224,30 3,29.776 3,29.5C3,29.224 3.224,29 3.5,29L10.5,29C10.776,29 11,29.224 11,29.5M11,23.5C11,23.776 10.776,24 10.5,24L3.5,24C3.224,24 3,23.776 3,23.5C3,23.224 3.224,23 3.5,23L10.5,23C10.776,23 11,23.224 11,23.5M33,29.5C33,29.776 32.776,30 32.5,30L25.5,30C25.224,30 25,29.776 25,29.5C25,29.224 25.224,29 25.5,29L32.5,29C32.776,29 33,29.224 33,29.5M22,23.5C22,23.776 21.776,24 21.5,24L14.5,24C14.224,24 14,23.776 14,23.5C14,23.224 14.224,23 14.5,23L21.5,23C21.776,23 22,23.224 22,23.5M22,17.5C22,17.776 21.776,18 21.5,18L14.5,18C14.224,18 14,17.776 14,17.5C14,17.224 14.224,17 14.5,17L21.5,17C21.776,17 22,17.224 22,17.5M22,29.5C22,29.776 21.776,30 21.5,30L14.5,30C14.224,30 14,29.776 14,29.5C14,29.224 14.224,29 14.5,29L21.5,29C21.776,29 22,29.224 22,29.5M33,23.5C33,23.776 32.776,24 32.5,24L25.5,24C25.224,24 25,23.776 25,23.5C25,23.224 25.224,23 25.5,23L32.5,23C32.776,23 33,23.224 33,23.5M33,17.5C33,17.776 32.776,18 32.5,18L25.5,18C25.224,18 25,17.776 25,17.5C25,17.224 25.224,17 25.5,17L32.5,17C32.776,17 33,17.224 33,17.5M34.5,35L1.5,35C1.224,35 1,34.776 1,34.5L1,9L35,9L35,34.5C35,34.776 34.775,35 34.5,35M1.5,1L34.5,1C34.776,1 35,1.224 35,1.5L35,8L1,8L1,1.5C1,1.224 1.224,1 1.5,1M34.5,0L1.5,0C0.673,0 0,0.675 0,1.5L0,34.5C0,35.328 0.673,36 1.5,36L34.5,36C35.327,36 36,35.328 36,34.5L36,1.5C36,0.674 35.327,0 34.5,0",
    style: {
      fill: "rgb(20,95,140)",
      stroke: "rgb(20,95,140)",
      strokeWidth: "0.68px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKalender, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/kalender.d92d73db.svg";
export { ForwardRef as ReactComponent };